import RequiredNoteGray from '../../../components/utilities/RequiredNoteGray';
import "./InputCandidateInfo.css";
import React, { useState } from "react";

const InputCandidateInfo = ({
  icon,
  inputRef,
  onClick = () => {},
  idName,
  marginRight = "20px",
  divWidth = "",
  setField,
  field,
  placeHolder,
  type = "text",
  className = "",
  style = {},
  required = false,
  disabled = false,
  width = "208px",
  onKeyDown = () => {},
  onFocus = () => {},
  onBlur = () => {},
  hidden = false
}) => {
  const [isFocused, setIsFocused] = useState(false);
  if (hidden) return "";

  
  if (idName) {
    const showFloatingLabel = isFocused || field;
    return (
      <div 
        className={`input-shell ${showFloatingLabel ? 'input-shell-focused' : ''}`} 
        style={{ marginRight, width: divWidth || width, ...style }}>
        {showFloatingLabel && (
          <div className={`floating-label ${showFloatingLabel ? 'floating-label-focused' : ''}`}>
            {placeHolder} {required && <RequiredNoteGray />}
          </div>
        )}
        <div className="input-design">
          {!showFloatingLabel && (
            <>
              <img className="input-icon" src={icon} alt="icon" />
              <div className="input-placeholder">{placeHolder} {required && <RequiredNoteGray />}</div>
            </>
          )}
        </div>
        <input
          ref={inputRef}
          id={idName}
          type={type}
          disabled={disabled}
          onClick={onClick}
          onChange={(e) => setField(e)}
          value={field}
          onKeyDown={onKeyDown}
          onFocus={(e) => {
            setIsFocused(true);
            onFocus(e); 
         }}
          onBlur={(e) => {
              setIsFocused(false);
              onBlur(e);
          }}
          required={required}
          className={`form-control input-candidate-field ${className}`}
        />
      </div>
    );
  }

  const showFloatingLabel = isFocused || field;
  return (
    <div 
      className={`input-shell ${showFloatingLabel ? 'input-shell-focused' : ''}`}
      style={{ marginRight, width: divWidth || width, ...style }}>
      {showFloatingLabel && (
        <div className={`floating-label ${showFloatingLabel ? 'floating-label-focused' : ''}`}>
          {placeHolder} {required && <RequiredNoteGray />}
        </div>
      )}
      <div className="input-design">
        {!showFloatingLabel && (
          <>
            <img className="input-icon" src={icon} alt="icon" />
            <div className="input-placeholder">{placeHolder} {required && <RequiredNoteGray />}</div>
          </>
        )}
      </div>

      <input
        ref={inputRef}
        type={type}
        disabled={disabled}
        onClick={onClick}
        onChange={(e) => setField(e)}
        value={field}
        onKeyDown={onKeyDown}
        onFocus={(e) => {
            setIsFocused(true);
            onFocus(e); 
         }}
          onBlur={(e) => {
              setIsFocused(false);
              onBlur(e);
          }}
        required={required}
        className={`form-control input-candidate-field ${className}`}
        
      />
    </div>
  );
};

export default InputCandidateInfo;